export const memberPathPrefix = "/mp";
export const memberSettingsPathPrefix = "/mp/settings";

export const ORG_CODE_PARAM = ":orgCode";

export function buildMemberPath(orgCode: string): string {
  return `${memberPathPrefix}/${orgCode}`;
}

export function buildMemberSettingsPath(orgCode: string): string {
  return `${memberPathPrefix}/${orgCode}/settings`;
}

export function toMemberPath(subpath: string): string {
  return `${memberPathPrefix}/${subpath}`;
}
